// extracted by mini-css-extract-plugin
export default {"wrap":"CarTypes_wrap__OMIIT","selected":"CarTypes_selected__psPWX"};